<template>
  <div>
    <div class="content">
      <div>
        <div class="container">
          <div class="row">
            <div
              v-if="directusContent.contentbox_1"
              v-dompurify-html="directusContent.contentbox_1"
              class="col-12"
            />
          </div>
        </div>
      </div>
      <error-500-content
        v-if="directusError"
      />
    </div>
  </div>
</template>

<script>
import Error500Content from 'components/errors/Error500Content.vue';
import CMSData from 'mixins/CMSData';

export default {
  name: 'Privacy',
  i18nOptions: { namespaces: 'privacy' },
  components: {
    Error500Content,
  },
  mixins: [CMSData],
  data() {
    return {
      cmsParams: {
        collection: 'landingpage',
        pageAlias: 'data-protect',
        fields: [
          'json_meta',
          'contentbox_1',
        ],
      },
    };
  },
};
</script>
